module.exports = __webpack_public_path__ + "female-user-icon.7982dfc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/female-user-icon.png
// module id = iEF/
// module chunks = 0